import { OnInit } from '@angular/core';
var RingComponent = /** @class */ (function () {
    function RingComponent() {
        this.index = 0;
        this.totalInColumn = 6;
        this.ring = null;
    }
    Object.defineProperty(RingComponent.prototype, "percentHeight", {
        get: function () {
            return (1 / this.totalInColumn) * 100;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RingComponent.prototype, "ringHeight", {
        get: function () {
            var percent = this.percentHeight;
            return percent.toString() + 'vh';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RingComponent.prototype, "ringTitleSize", {
        get: function () {
            var percent = this.percentHeight * 0.33;
            return percent.toString() + 'vh';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RingComponent.prototype, "groupFontSize", {
        get: function () {
            var percent = this.percentHeight * 0.2;
            return percent.toString() + 'vh';
        },
        enumerable: true,
        configurable: true
    });
    RingComponent.prototype.ngOnInit = function () { };
    return RingComponent;
}());
export { RingComponent };
